import { Metadata } from "@dropbox/dash-component-library";
import { LabelGroup } from "@dropbox/dig-components/label_group";
import { Text } from "@dropbox/dig-components/typography";
import { Highlighter } from "@mirage/search/SearchResults/Highlighter";
import { isEmpty } from "lodash";

import { Box } from "@dropbox/dig-foundations";
import type { ReactNode } from "react";
import sharedStyles from "./shared.module.css";

export type DefaultResultRowProps = {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  currentQuery: string;
};

export const DefaultResultRow = ({
  icon,
  title,
  subtitle,
  currentQuery,
}: DefaultResultRowProps) => {
  const withLabelNode = (
    <Metadata>
      <Metadata.Item>
        <Text color={"standard"} size={"large"}>
          {/* NOTE: DashTruncateWithTooltip only supports strings as children, not react nodes */}
          <Box
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Highlighter
              title={title}
              highlightWords={
                currentQuery
                  ? currentQuery.split(" ").map((word) => word.trim())
                  : []
              }
              fontSize={"large"}
            />
          </Box>
        </Text>
      </Metadata.Item>
      {!isEmpty(subtitle) && (
        <Metadata.Item>
          <Text size={"medium"} color={"subtle"}>
            {subtitle}
          </Text>
        </Metadata.Item>
      )}
    </Metadata>
  );

  return (
    <Box className={sharedStyles.rowContainer} paddingLeft="Micro Medium">
      <LabelGroup
        style={{ padding: 0 }}
        withStartAccessory={icon}
        withLabel={withLabelNode}
        verticalAlignment={"center"}
        accessoryGap={"Micro Medium"}
      />
    </Box>
  );
};
DefaultResultRow.displayName = "DefaultResultRow";
